 <template>
    <el-dialog :visible.sync="visible" width="500px" append-to-body title="关闭工单" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">

        
        <el-form :model="form" size="mini" label-position="top" v-loading="loading">
            
            
            <el-form-item label="用户评分" >
                <el-rate
                    v-model="form.appraise_score"
                    :max="10" allow-half show-text
                    :colors="['#9e9e9e', '#ffeb3b', '#e91e63']"
                    :low-threshold="6"
                    :high-threshold="8.5"
                    :texts="['极差', '极差', '失望', '失望', '失望', '一般', '一般', '满意', '惊喜', '惊喜']">
                </el-rate>
            </el-form-item>

            
            <el-form-item label="用户评价" >
                <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.appraise_describe"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    data () {
        return {
                        visible: false,
            loading: false,

            formError: {},
            form: {
                id: null,
                appraise_score: 8,
                appraise_describe: null,
            }
        }
    },

    methods: {

        
       
        Open (id) {
            this.visible = true
            this.form.id = id
        },
        Close() {
            this.loading = false
            this.visible = false
        },
        SubmitForm() {
                        this.loading = true
            this.formError = {}

                        this.$http.post('/9api/pm/wo/update-close', this.form).then(rps => {
                                this.loading = false
                this.$emit('onChange')
                this.Close()
            })
        }
    }  
}
</script>